import React, { useState, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { Layout } from 'app/theme/layout'
import { Spinner, useNotify } from 'app/theme'
import { Radio, Checkbox } from 'app/theme/forms'
import { useClient } from 'jsonapi-react'
import useSearchParams from 'app/theme/useSearchParams'
import useSessionStorage from 'lib/useSessionStorage'

export default function GoogleCallback({ session }) {
  const client = useClient()
  const params = useSearchParams()
  const notify = useNotify()
  const history = useHistory()
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState()
  const [storage, setStorage] = useSessionStorage('calendar_auth', {})

  const handleFailure = () => {
    if (storage.service_id) {
      history.push(`/settings/services/${storage.service_id}`)
    } else {
      history.push(`/settings/services/`)
    }

    notify.show({
      theme: 'error',
      title: 'Error',
      message: 'Sorry, we are unable to sync with Google at the moment.',
    })
  }

  const saveCalendar = async data => {
    if (!loading) {
      setLoading(true)
    }

    const result = await client.mutate('calendars', {
      type: 'google',
      calendar_id: data.calendar_id,
      access_token: data.access_token,
      refresh_token: data.refresh_token,
      access_token_expires_at: data.access_token_expires_at,
      caterer: { id: session.caterer.id },
      caterer_service: { id: storage.service_id },
    })

    if (!result.data) {
      return handleFailure()
    } else {
      history.push(`/settings/services/${storage.service_id}`)

      notify.show({
        theme: 'success',
        title: 'Success',
        message: 'Calendar was connected.',
      })
    }
  }

  useEffect(() => {
    (async () => {
      if (!params.code) {
        return handleFailure()
      }

      if (params.state && params.state !== storage.state) {
        return handleFailure()
      }

      if (!storage.service_id) {
        return handleFailure()
      }

      const result = await client.mutate('calendar_credentials', {
        type: 'google',
        authorization_code: params.code,
      })

      if (!result.data || !result.data.available_calendars?.length) {
        return handleFailure()
      } else if (result.data.available_calendars.length === 1) {
        saveCalendar({
          ...result.data,
          calendar_id: result.data.available_calendars[0].id,
        })
      } else {
        setData(result.data)
        setLoading(false)
      }
    })()
  }, [])

  return (
    <Layout className="container py-12 max-w-3xl">
      {loading ? (
        <Spinner className="mx-auto my-100" />
      ) : (
        <div>
          <h1 className="font-platform text-3xl">
            Select Calendar
          </h1>
          <p className="font-light mb-6">
            Please select which calendar you want to connect.
          </p>
          <div className="grid gap-4 mb-8">
            {data.available_calendars?.map(cal => (
              <div
                key={cal.id}
                className="bg-white rounded shadow p-6 flex"
              >
                <Radio
                  value={cal.id}
                  label={cal.name}
                  checked={data.calendar_id === cal.id}
                  onChange={() => {
                    setData({ ...data, calendar_id: cal.id })
                  }}
                />
              </div>
            ))}
          </div>
          <div className="flex">
            <button
              children="Save"
              className="btn btn-blue px-10 py-2 rounded-sm"
              disabled={loading}
              onClick={() => {
                saveCalendar(data)
              }}
            />
          </div>
        </div>
      )}
    </Layout>
  )
}
